import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["url_segment_params", "url_filter_params", "url_search_params", "has_to_set"]

  initialize() {
    super.initialize();

    const controller = this;
    const { renderUrl, cacheKey } = this.element.dataset;
    const hasToSet = this.getTargetValue(this.has_to_setTarget)
    const urlSegmentParams = this.getTargetValue(this.url_segment_paramsTarget) // $("#url_segment_params").attr('data-params');
    const urlFilterParams = this.getTargetValue(this.url_filter_paramsTarget) // $("#url_filter_params").attr('data-params');
    const urlSearchParams = this.getTargetValue(this.url_search_paramsTarget) // $("#url_search_params").attr('data-params');

    if (urlSegmentParams !== "false") {
      this.renderSegmentMenu({selected_segment_id: urlSegmentParams});
    } else if (hasToSet !== "false") {
      this.renderSegmentMenu().done(() => {
        $.ajax({
          type: "GET",
          cache: false,
          url: renderUrl,
          data: {segment: "has_to_set", id: $("#blast_id").data('params')},
        }).done(() => controller.refreshPlugins());
      });
    } else if (urlFilterParams !== "false") {
      this.renderSegmentMenu({selected_segment_id: 'false'}).done(() => {
        const filters = JSON.parse(urlFilterParams.replaceAll('=>', ':'));
        controller.updateFilterSummary(filters);

        controller.fetchChart(renderUrl, {segment: "filter", params_array: filters});
        $.ajax({
          type: "GET",
          url: renderUrl,
          data: {segment: "filter", params_array: filters, cache_key: cacheKey}
        }).done(() => controller.refreshPlugins());
      });
    } else if (urlSearchParams !== "false") {
      this.renderSegmentMenu().done(() => {
        const searchField = urlSearchParams.includes("@") ? "email" : "name";
        const filters = [{
          query_type: "contains",
          filter_type: "string",
          search_field: searchField,
          search_value: urlSearchParams
        }];
        controller.updateFilterSummary(filters);

        controller.fetchChart("guests/render_guest_table.js", {segment: "filter", params_array: filters});
        $.ajax({
          type: "GET",
          url: "guests/render_guest_table.js",
          data: {segment: "filter", params_array: filters, cache_key: cacheKey}
        }).done(() => controller.refreshPlugins());
      });
    } else {
      this.renderSegmentMenu({selected_segment_id: "first_default"});
    }
  }

  refreshPlugins(){
    $.fn.matchHeight._update();
    feather.replace();
    $('[data-toggle="tooltip"]').tooltip();
  };

// Helper for the shared "render_segment_menu" request
  renderSegmentMenu(data = {}) {
    const controller = this;
    const { renderUrl, cacheKey } = this.element.dataset;
    return $.ajax({
      type: "GET",
      // cacheKey is account.updated_at, which does not move when a segment count
      // does, so the browser would serve a cached menu and keep showing counts
      // that update_counter has already corrected.
      cache: false,
      url: `/app/${this.accountId}/guests/render_segment_menu.js`,
      data: { render_url: renderUrl, cache_key: cacheKey, ...data },
      complete: () => controller.refreshPlugins()
    });
  };

  get accountId() {
    return document.body.dataset.accountId || $("body").data("account-id")
  }

  // Mirrors filter_guests_controller#fetchChart: fires the chart request in
  // parallel with the table request for the deep-link entry points that render
  // the table directly (rather than through a segment click).
  chartUrlFrom(url) {
    return url.replace("render_guest_table", "render_guest_chart")
  }

  // See filter_guests_controller#hasChartEndpoint.
  hasChartEndpoint(url) {
    return typeof url === "string" && url.includes("guests/render_guest_table")
  }

  fetchChart(url, data) {
    if (!this.hasChartEndpoint(url)) return

    window.visitsData = undefined;
    window.visitsTitle = undefined;
    $.ajax({
      type: "GET",
      url: this.chartUrlFrom(url),
      data: data
    })
  }

  getTargetValue(element) {
    return element.dataset.params;
  }

  updateFilterSummary(filters) {
    filters = JSON.stringify(filters);
    const { cacheKey, renderUrl } = this.element.dataset;
    $("#filter-summary").attr("data-filters", filters)
        .html(`
              <div data-controller='general--render-filters' 
                   data-render-url='${renderUrl}' 
                   data-filters='${filters}' 
                   data-target='general--render-filters.filters'
                   data-cache-key='${cacheKey}'>
              </div>
        `);
  }
}
